export default "__VITE_ASSET__cadaad5e__"